import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider }  from './context/AuthContext';
import ProtectedRoute    from './components/ProtectedRoute';
import NavBar            from './components/NavBar';
import Login             from './pages/Login';
import Register          from './pages/Register';
import GoogleCallback    from './pages/GoogleCallback';
import Onboarding        from './pages/Onboarding';
import Dashboard         from './pages/Dashboard';
import BudgetVsActual    from './pages/BudgetVsActual';
import Sandbox           from './pages/Sandbox';
import Forecast          from './pages/Forecast';
import Alerts            from './pages/Alerts';
import Status            from './pages/Status';
import Profile           from './pages/Profile';
import Admin            from './pages/Admin';
import ForgotPassword   from './pages/ForgotPassword';
import ResetPassword    from './pages/ResetPassword';
import Connect          from './pages/Connect';
import Disconnected     from './pages/Disconnected';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login"             element={<Login />} />
          <Route path="/register"          element={<Register />} />
          <Route path="/signup"            element={<Register />} />
          <Route path="/auth/callback"     element={<GoogleCallback />} />
          <Route path="/forgot-password"   element={<ForgotPassword />} />
          <Route path="/reset-password"    element={<ResetPassword />} />
          <Route path="/connect"           element={<Connect />} />
          <Route path="/disconnected"      element={<Disconnected />} />

          {/* Onboarding — requires auth but no nav */}
          <Route path="/onboarding" element={
            <ProtectedRoute>
              <Onboarding />
            </ProtectedRoute>
          } />

          {/* Protected dashboard routes */}
          <Route path="/*" element={
            <ProtectedRoute>
              <NavBar />
              <main className="main-content">
                <Routes>
                  <Route path="/"         element={<Dashboard />} />
                  <Route path="/bva"      element={<BudgetVsActual />} />
                  <Route path="/sandbox"  element={<Sandbox />} />
                  <Route path="/forecast" element={<Forecast />} />
                  <Route path="/alerts"   element={<Alerts />} />
                  <Route path="/status"   element={<Status />} />
                  <Route path="/profile"  element={<Profile />} />
                  <Route path="/admin"    element={<Admin />} />
                </Routes>
                <footer style={{
                  textAlign:  'center',
                  padding:    '1.5rem',
                  color:      '#94A3B8',
                  fontSize:   '0.75rem',
                  borderTop:  '1px solid #E2E8F0',
                  marginTop:  '2rem',
                }}>
                  Powered by Acct4Cast, LLC · acct4cast.com · Data from QuickBooks
                </footer>
              </main>
            </ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;